export default "__VITE_ASSET__CQRRFOaQ__"